import { Suspense } from 'react'
import { Outlet } from 'react-router'

import Loading from '@/components/generics/Loading'
import RouterStoreProvider from '@/contexts/router'
import { GuideTourProvider, GuideTourRouteListener } from '@/guide-tour'
import { sellerGuideTourRegistry } from '@/tours'

export function RootLayout() {
  return (
    <Suspense fallback={<Loading />}>
      <RouterStoreProvider>
        <GuideTourProvider registry={sellerGuideTourRegistry}>
          <GuideTourRouteListener />
          <Outlet />
        </GuideTourProvider>
      </RouterStoreProvider>
    </Suspense>
  )
}
